import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { APP_CONSTANTS as CONSTANTS } from '@app/app.constants';
import { environment } from '@environment';

import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { ServerMock } from '../../data/mocks/app-serve.mock';
import { ErrorService } from '../../domain/services/error.service';
import { AppFacade } from '../../facades/app.facade';
import { HandleTokenService } from '../services/handle-token.service';

@Injectable()
export class AppMockInterceptorService implements HttpInterceptor {
  private _localServer: ServerMock;

  constructor(
    private _handleTokenServie: HandleTokenService,
    private _errorService: ErrorService,
    private _appFacade: AppFacade
  ) {
    this._localServer = new ServerMock();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isRequestOpenPay = req.url.indexOf(environment.openpay_url) > -1;
    return this._checkIsTestEnv(req) && !isRequestOpenPay
      ? this._sendLocalServer(req)
      : next.handle(req);
  }

  private _checkIsTestEnv(req: HttpRequest<any>): boolean {
    const { production, isTestServer } = environment;
    const hasTestToken = this._handleTokenServie.getAccessToken() === CONSTANTS.TEST_INFO.TOKEN;
    return !production && (isTestServer || hasTestToken);
  }

  private _sendLocalServer(req: any): Observable<HttpEvent<any>> {
    return this._localServer.request(req).pipe(
      map((response: any) => {
        this._checkTokenResponse(response);
        return response;
      }),
      catchError((err: HttpErrorResponse) => this._catchError(req, err))
    );
  }

  private _checkTokenResponse(response: any) {
    if (response.token) {
      this._handleTokenServie.setAccessToken(response.token);
    }
    if (response.body && response.body.token) {
      this._handleTokenServie.setAccessToken(response.body.token);
    }
    if (response.headers && response.headers.get('token')) {
      this._handleTokenServie.setAccessToken(response.headers.get('token'));
    }
  }

  private _catchError(req: HttpRequest<any>, error: any) {
    const { status } = error;
    const isUnathorized = status === CONST.HTTP_CODES.UNAUTHORIZED;

    if (isUnathorized) this._appFacade.closeSession();

    this._errorService.handleError(error, req);
    return throwError(() => error);
  }
}
